import React from 'react'
import './about.css'
import ME from '../../common/image/resume-img.jpg'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About Me" />
          </div>
        </div>
        <div className="about__content">
          {/* <div className="about__cards">
            <article className='about__card'>
              <FaAward className='about__icon'></FaAward>
              <h5>Experience</h5>
              <small>4+ Years Working</small>
            </article>

          </div> */}
          <h1>Software Engineer</h1>
          <p>
          Hello! My name is Sang Hwa, Choi and I enjoy solving complex problem. 
          I born and bred Korea with Bechelor's degree in Computer Engineering and plenty of experience developing windows and web base app.
          <br />
          <br />
          I currently developing a web based ERP system uging Node & React to get the best performance.
          This system will be published free of charge for small businesses to use.
          </p>

          {/* <div className='cta'>
            <a href="#contact" className='btn btn-primary'>Let's Talk</a>
          </div> */}
          

        </div>
      </div>
    </section>
  )
}

export default About